import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; 
import '../design/signup.css';
import Footer from "../components/ui/footer";

const SignUpPage = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [referral, setReferral] = useState('');
  const [agreed, setAgreed] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!agreed) {
      setError('You must agree to the Terms and Privacy Policy.');
      return;
    }

    const validReferralCodes = ['REMY', 'ANGELA', 'WALTER', 'JACOB', 'PARKER', 'AMY', 'OLIVIA', 'CHEYLA'];
    if (referral && !validReferralCodes.includes(referral.trim().toUpperCase())) {
      setError('Invalid referral code.');
      return;
    }

    try {
      const response = await axios.post('https://api.deliquentauction.com/auth/signup/', {
        first_name: firstName,
        last_name: lastName,
        username,
        email,
        password,
        referral
      });

      if (response.data) {
        navigate('/login');
      }
    } catch (err) {
      setError('Failed to create account. Please try again.');
    }
  };

  return (
    <div className="signup-wrapper">
      <div className="signup-container">
        <a href="/">
          <img src="/logo.png" alt="Logo" />
        </a>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="First Name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
          <input
            type="text"
            placeholder="Last Name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <input
            type="referral"
            placeholder="Referral Code (Optional)"
            value={referral}
            onChange={(e) => setReferral(e.target.value)}
          />
          
          <div className="terms-checkbox">
            <input
              type="checkbox"
              id="terms"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
            />
            <label htmlFor="terms">
              I agree to the <a href="/terms" target="_blank" rel="noopener noreferrer">Terms and Conditions</a> and <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            </label>
          </div>

          <button type="submit">Sign Up</button>
          {error && <div className="error">{error}</div>}
        </form>
        <p>
          Already have an account? <a href="/login">Login here</a>
        </p>
      </div>
      <div className="signup-footer">
      <Footer />
      </div>
  </div>
  );
};

export default SignUpPage;
